// types
import { i18nEaiDeliveryContracts } from 'models/i18n';

// ==============================|| I18N EN LONG-TERM CONTRACTS ||============================== //

const enEaiDeliveryContracts: i18nEaiDeliveryContracts = {
  createDeliveryContractWizard: {
    title: 'Create delivery contract',
    step01: 'Contracting Parties',
    step02: 'Subject of a contract',
    save: 'Create delivery contract'
  },
  deliveryContractList: {
    title: 'Long term contracts List',
    searchInput: 'Enter name/ID/code',
    createEntityButton: 'Create contract',
    columns: {
      id: 'ID',
      code: 'Code',
      type: 'Type',
      name: 'Name',
      startDate: 'Start date',
      endDate: 'End date',
      status: 'Status'
    },
    filter: {
      validityFrom: 'Validity from',
      validityTo: 'Validity to',
      status: 'Status',
      type: 'Type'
    }
  },
  deliveryContractDetail: {
    contractData: {
      title: 'Contract info',
      basicInfo: 'Basic info',
      contractType: 'Contract type'
    },
    deliveryPoints: {
      title: 'Delivery points',
      columns: {
        deliveryPointId: 'Delivery point ID',
        name: 'Name',
        eic: 'EIC',
        actions: 'Actions'
      },
      addDeliveryPoint: 'Add delivery point'
    }
  },
  input: {
    ProducerMarketParticipant: 'Producer',
    ConsumerMarketParticipant: 'Consumer',
    DeliveryContractType: 'Contract type',
    Amount: 'Amount',
    Unit: 'Unit',
    UnitPrice: 'Unit price',
    IndexPriceRatio: 'Index price ratio',
    StartDate: 'Start date',
    EndDate: 'End date',
    Id: 'ID',
    Name: 'Name',
    Description: 'Description',
    Code: 'Code',
    DeliveryPoint: 'Delivery point'
  },
  validation: {
    'ProducerMarketParticipant-required': 'Producer is required',
    'ConsumerMarketParticipant-required': 'Consumer is required',
    'DeliveryContractType-required': 'Delivery contarct type is required',
    'Amount-required': 'Amount is required',
    'Amount-number': 'Amount must be positive number in decimal form',
    'Unit-required': 'Unit is required',
    'UnitPrice-required': 'Unit price is required',
    'UnitPrice-number': 'Unit price must be positive number in decimal form',
    'IndexPriceRatio-required': 'Index price ratio is required',
    'IndexPriceRatio-number':
      'Index price ratio must be number in decimal form',
    'IndexPriceRatio-max': 'Index price ratio must be value in range 0-1000',
    'StartDate-required': 'Start date is required',
    'StartDate-beforeEndDate': 'Start date must be before end date',
    'EndDate-required': 'End date is required',
    'EndDate-afterStartDate': 'End date must be before start date',
    'Name-required': 'Name is required',
    'Name-length': 'Name length must be max 256 chars',
    'Code-required': 'Code is required',
    'Code-length': 'Code length must be max 64 alfa numeric chars',
    'Description-length': 'Description length must be max 2000 chars'
  }
};

export default enEaiDeliveryContracts;
